import { Component, OnInit, OnDestroy, ApplicationRef, inject } from '@angular/core';
import { Router, RouterOutlet } from '@angular/router';
import { CommonModule } from '@angular/common';
import { MsalService, MsalBroadcastService } from '@azure/msal-angular';
import { InteractionStatus, RedirectRequest } from '@azure/msal-browser';
import { Subject } from 'rxjs';
import { filter, first, takeUntil } from 'rxjs/operators';
import { environment } from '../environments/environment';
import { AppUpdateService } from './app-update-service';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.css']
})
export class AppComponent implements OnInit, OnDestroy {
  isIframe = false;
  loginDisplay = false;

  private readonly _destroying$ = new Subject<void>();
  

  constructor(
    private authService: MsalService,
    private msalBroadcastService: MsalBroadcastService,
    private appRef: ApplicationRef,
    private router: Router, private appUpdate: AppUpdateService
  ) {

     this.appUpdate.init();
  }

ngOnInit(): void {
    this.isIframe = window !== window.parent && !window.opener;

    // ✅ CORREÇÃO: Apenas definir loginDisplay inicial, NÃO chamar login aqui
    this.setLoginDisplay();
    console.log('🔍 ngOnInit - loginDisplay inicial:', this.loginDisplay);

    // ✅ ÚNICO LUGAR onde verificamos se precisa fazer login
    this.msalBroadcastService.inProgress$
      .pipe(
        filter((status) => status === InteractionStatus.None),
        takeUntil(this._destroying$)
      )
      .subscribe(() => {
        console.log('🔍 MSAL interaction completed, updating loginDisplay');
        this.setLoginDisplay();
        this.checkAndSetActiveAccount();
        
        console.log('🔍 loginDisplay após update:', this.loginDisplay);
        
        // ✅ SÓ AQUI verificar se precisa fazer login
        if (!this.loginDisplay && !this.isIframe) {
          console.log('🔍 Precisa fazer login, chamando login()...');
          this.login();
        } else {
          console.log('🔍 Não precisa fazer login - loginDisplay:', this.loginDisplay, 'isIframe:', this.isIframe);
        }
      });
  }

  ngOnDestroy(): void {
    this._destroying$.next();
    this._destroying$.complete();
  }

  private setLoginDisplay(): void {
    const accounts = this.authService.instance.getAllAccounts();
    this.loginDisplay = accounts.length > 0;
    console.log('🔍 setLoginDisplay - accounts:', accounts.length, 'loginDisplay:', this.loginDisplay);
  }

  private checkAndSetActiveAccount(): void {
    const current = this.authService.instance.getActiveAccount();
    const allAccounts = this.authService.instance.getAllAccounts();
    
    console.log('🔍 checkAndSetActiveAccount - current:', !!current, 'allAccounts:', allAccounts.length);
    
    if (!current && allAccounts.length > 0) {
      this.authService.instance.setActiveAccount(allAccounts[0]);
      console.log('🔍 Active account set');
      
      // ✅ FORÇAR UPDATE do loginDisplay após definir conta ativa
      this.setLoginDisplay();
    }
  }

  private login(): void {
  console.log('🔍 Iniciando login interativo...');
  
  const loginRequest = {
    scopes: ["user.read"]
  };

  this.authService.loginRedirect(loginRequest);
}

}

